export const type = 'prices';

export const defaultResponse = {};
export const flightSearchEndpoints = (builder) => ({

    getPricesReturn: builder.query({
        query: ({origin, destination}) => ({
            url: `/flight-search/returns/${destination}/${origin}`,
            method: 'GET'
        }),
        transformResponse: (data, meta) => {
            if (meta?.response?.status === 404) {
                return defaultResponse;
            }
            return data?.Dates || null;
        }
    }),

    getPricesOutbound: builder.query({
        query: ({origin, destination}) => ({
            url: `/flight-search/outbound/${origin}/${destination}`,
            method: 'GET',
        }),
        transformResponse: (data, meta) => {
            if (meta?.response?.status === 404) {
                return defaultResponse;
            }
            return data?.Dates || null;
        }
    }),
});

export default flightSearchEndpoints;
